import React, { useEffect, useState } from 'react';
import { useData } from '../../../hooks/useData';
import { useToast } from '../../../hooks/useToast';
import { usersManagementServices } from '../../../APIServices/usersManagementServices';
import Swal from 'sweetalert2';
import Pagination from '../../../hooks/Pagination';
import { usersDesignationServices } from '../../../APIServices/usersDesignationServices';

function UpdateUser({
  getUserData,
  setModalOpen,
  userData,
  setConfirm,
  confirm,
  title
}) {
  const toast = useToast();
  const [buttonLoader, setButtonLoader] = useState(false);
  const [designationList, setDesignationList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);

  const [status, setStatus] = useState("");
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [gender, setGender] = useState("");
  const [designation, setDesignation] = useState("");
  const [phone, setPhone] = useState("");
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");

  const updateUserData = async () => {
    setButtonLoader(true);
    try {
      let userDatas = {};
      userDatas.userId = userData?.userId;
      userDatas.status = status;
      userDatas.firstName = firstName;
      userDatas.middleName = middleName;
      userDatas.lastName = lastName;
      userDatas.gender = gender;
      userDatas.designation = designation;
      userDatas.phone = phone;
      userDatas.country = country;
      userDatas.state = state;
      userDatas.city = city;
      userDatas.zipCode = zipCode;
      userDatas.address1 = address1;
      userDatas.address2 = address2;
      let data = await usersManagementServices.updateUserData(userDatas);
      if (data?.statusCode === 200) {
        toast(data?.customMessage || `${title} updated successfully.`, 'ok');
        setStatus("");
        setFirstName("");
        setMiddleName("");
        setLastName("");
        setGender("");
        setDesignation("");
        setPhone("");
        setCountry("");
        setState("");
        setCity("");
        setZipCode("");
        setAddress1("");
        setAddress2("");
        getUserData();
        setConfirm(false);
        setModalOpen("");
      } else {
        toast(data?.customMessage || `Unable to update ${title?.toLowerCase() || 'user'}.`, 'warn');
      }
    } catch (error) {
      toast(`Unable to update ${title?.toLowerCase() || 'user'}. Please try again.`, 'warn');
    } finally {
      setButtonLoader(false);
    }
  };

  const getUserDesignationData = async () => {
    let data = await usersDesignationServices.getUserDesignationData("active", userData?.roleType);
    setDesignationList(data?.data || []);
  };

  const getCountries = async () => {
    let data = await usersManagementServices.getCountries();
    setCountryList(data || []);
  };

  const getStates = async (countryName) => {
    let data = await usersManagementServices.getStates(countryName);
    setStateList(data || []);
  };

  const getCities = async (stateName) => {
    let data = await usersManagementServices.getCities(stateName);
    setCityList(data || []);
  };

  useEffect(() => {
    getCountries();
  }, []);

  useEffect(() => {
    setStatus(userData?.status || "")
    setFirstName(userData?.firstName || "")
    setMiddleName(userData?.middleName || "")
    setLastName(userData?.lastName || "")
    setGender(userData?.gender || "")
    setDesignation(userData?.designation || "")
    setPhone(userData?.phone || "")
    if (userData?.roleType) {
      getUserDesignationData();
    }
    setCountry(userData?.country || "")
    if (userData?.country) {
      getStates(userData?.country)
    }
    setState(userData?.state || "")
    if (userData?.state) {
      getCities(userData?.state)
    }
    setCity(userData?.city || "")
    setZipCode(userData?.zipCode || "")
    setAddress1(userData?.address1 || "")
    setAddress2(userData?.address2 || "")
  }, [userData]);

  return (
    <div
      className="modal-backdrop"
      onClick={() =>
        setModalOpen("")
      }
    >
      <div
        className="modal"
        style={{ maxWidth: 480 }}
        onClick={(e) =>
          e.stopPropagation()
        }
      >
        <div className="modal-head">
          <div>
            <div className="modal-title">
              Update {title}
            </div>

            <div className="xs muted">
              Update {title} Details for the platform
            </div>
          </div>

          <button
            className="icon-btn"
            onClick={() =>
              setModalOpen("")
            }
          >
            <i className="ti ti-x" />
          </button>
        </div>

        <div className="modal-body">
          <div className="field">
            <label className="field-label">
              Status <span className="req">*</span>
            </label>
            <select
              className="inp"
              disabled={buttonLoader}
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              <option value="">Select Status</option>
              <option hidden value="pending">Pending</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
              <option value="freeze">Freeze</option>
            </select>
          </div>

          <div className="field">
            <label className="field-label">
              First Name <span className="req">*</span>
            </label>
            <input
              className="inp"
              autoFocus
              disabled={buttonLoader}
              placeholder="Enter first name"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
          </div>

          <div className="field">
            <label className="field-label">Middle Name</label>
            <input
              className="inp"
              disabled={buttonLoader}
              placeholder="Enter middle name"
              value={middleName}
              onChange={(e) => setMiddleName(e.target.value)}
            />
          </div>

          <div className="field">
            <label className="field-label">
              Last Name
            </label>
            <input
              className="inp"
              disabled={buttonLoader}
              placeholder="Enter last name"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
          </div>

          <div className="field">
            <label className="field-label">
              Gender
            </label>
            <select
              className="inp"
              disabled={buttonLoader}
              value={gender}
              onChange={(e) => setGender(e.target.value)}
            >
              <option value="">Select Gender</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
              <option value="other">Other</option>
            </select>
          </div>

          <div className="field">
            <label className="field-label">
              Designation
            </label>
            <select
              className="inp"
              disabled={buttonLoader || designationList?.length === 0}
              value={designation}
              onChange={(e) => setDesignation(e.target.value)}
            >
              <option value="">Select Designation</option>
              {designationList?.map((item) => (
                <option value={item.designation}> {item.designation} </option>
              ))}
            </select>
          </div>

          <div className="field">
            <label className="field-label">
              Phone
            </label>
            <input
              className="inp"
              disabled={buttonLoader}
              placeholder="Enter phone number"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </div>

          <div className="field">
            <label className="field-label">Country</label>
            <select
              className="inp"
              disabled={buttonLoader || countryList?.length === 0}
              value={country}
              onChange={(e) => { setCountry(e.target.value); getStates(e.target.value) }}
            >
              <option value="">Select Country</option>
              {countryList?.map((item) => (
                <option value={item.name}> {item.name} </option>
              ))}
            </select>
          </div>

          <div className="field">
            <label className="field-label">State</label>
            <select
              className="inp"
              disabled={buttonLoader || stateList?.length === 0}
              value={state}
              onChange={(e) => { setState(e.target.value); getCities(e.target.value) }}
            >
              <option value="">Select State</option>
              {stateList?.map((item) => (
                <option value={item.name}> {item.name} </option>
              ))}
            </select>
          </div>

          <div className="field">
            <label className="field-label">City</label>
            <select
              className="inp"
              disabled={buttonLoader || cityList?.length === 0}
              value={city}
              onChange={(e) => setCity(e.target.value)}
            >
              <option value="">Select City</option>
              {cityList?.map((item) => (
                <option value={item.name}> {item.name} </option>
              ))}
            </select>
          </div>

          <div className="field">
            <label className="field-label">Zip Code</label>
            <input
              className="inp"
              disabled={buttonLoader}
              placeholder="Enter zip code"
              value={zipCode}
              onChange={(e) => setZipCode(e.target.value)}
            />
          </div>

          <div className="field">
            <label className="field-label">Address Line 1</label>
            <textarea
              className="inp"
              disabled={buttonLoader}
              placeholder="Enter address line 1"
              value={address1}
              onChange={(e) => setAddress1(e.target.value)}
            />
          </div>

          <div className="field">
            <label className="field-label">Address Line 2</label>
            <textarea
              className="inp"
              disabled={buttonLoader}
              placeholder="Enter address line 2"
              value={address2}
              onChange={(e) => setAddress2(e.target.value)}
            />
          </div>
        </div>
        <div className="modal-foot">
          {confirm ?
            <>
              <button
                className="btn btn-ghost"
                onClick={() => setConfirm(false)}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary d-flex align-items-center justify-content-center gap-2"
                onClick={updateUserData}
                disabled={buttonLoader || !firstName || !status}
              >
                {buttonLoader ? (
                  <>
                    <div className="buttonLoader"></div>
                    <span>Updating...</span>
                  </>
                ) : (
                  <>
                    <i className="ti ti-check"></i>
                    <span>Yes, Update It!</span>
                  </>
                )}
              </button>
            </>
            :
            <>
              <button
                className="btn btn-ghost"
                onClick={() => setModalOpen("")}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary d-flex align-items-center justify-content-center gap-2"
                onClick={() => setConfirm(true)}
              >
                Update {title}
              </button>
            </>
          }
        </div>
      </div>
    </div>
  );
}

export default UpdateUser;
